<template>
  <div class="otp-transprarent-2">
    <img
      class="otp-transprarent-2-1"
      src="../img/otp-transprarent-2@2x.png"
      alt="otp transprarent 2"
    />
    <img
      class="otp-transprarent-2-2"
      src="../img/activate-logo-mono-darkbg-1@2x.png"
      alt="otp transprarent 2"
    />
  </div>
</template>

<script>
export default {
  name: "OtpTransprarent2",
};
</script>

<style>
.otp-transprarent-2,
.otp-transprarent-2-2 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  width: 300px;
  margin-top: 30px;
}

.otp-transprarent-2-1,
.otp-transprarent-2-3 {
  height: 57.45px;
  min-width: 300px;
  object-fit: cover;
  position: relative;
}
</style>
